import { render } from "./meetBarka.vue?vue&type=template&id=7056e8e9"
import script from "./meetBarka.vue?vue&type=script&lang=js"
export * from "./meetBarka.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__